'use strict';

var angular = require('angular');
module.exports = angular.module('AVRO.Common.IdService', []).factory('IdService', require('./services/IdService'));